import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() diameter = 44;
  @Input() strokeWidth = 3;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    if (this.host.nativeElement.classList.contains('inline-loader')) {
      this.diameter = 16;
      this.strokeWidth = 2;
    }
  }
}
